var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-empty"},[(_setup.isSlideTmpl)?_c(_setup.SvgIcons,{staticClass:"c-empty-svg",attrs:{"name":"icon_empty_slide"}}):_c(_setup.SvgIcons,{staticClass:"c-empty-svg",attrs:{"name":"icon_empty"}}),_c('span',{staticClass:"c-empty-span"},[_vm._v(_vm._s(_setup.defineText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }